export default __webpack_public_path__ + "static/media/779.b574cdd4.gif";